import { Component, inject, input } from "@angular/core";
import { DialogRef } from "@angular/cdk/dialog";

import { FormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export interface TicketForDelete {
  id: number;
  order_nr: string;
  project_name?: string;
  status_name?: string;
}

@Component({
  selector: "app-ticket-delete-dialog",
  templateUrl: "./ticket-delete-dialog.component.html",
  standalone: true,
  imports: [FormsModule, FontAwesomeModule],
})
export class TicketDeleteDialogComponent {
  tickets = input<TicketForDelete[]>([]);

  confirmed = false;
  inputCount: number | null = null;

  dialogRef = inject(DialogRef);

  constructor(library: FaIconLibrary) {
    library.addIcons(faTrash);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    if (this.isDeleteEnabled()) {
      this.dialogRef.close(true);
    }
  }

  isDeleteEnabled(): boolean {
    return this.confirmed && this.inputCount === this.tickets().length;
  }
}
